import { SectionHelper, Text, TextButton } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/fe-essentials/react';
import { StatusAlertSmall } from '@wix/wix-ui-icons-common';
import React, { useEffect } from 'react';
import { BiCtaNames, BiNotificationTypes } from '../bi/types';
import { PERMISSIONS_ARTICLE_ID } from '../consts';
import { useBiLogger } from '../hooks/use-bi-logger';
import { useSessionInfoContext } from '../hooks/use-session-info-context';
import { getArticleLink } from '../utils/get-article-link';
export const MissingSavePermissionWarning = () => {
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    locale
  } = useSessionInfoContext();
  useEffect(() => {
    biLogger.notificationView({
      notificationType: BiNotificationTypes.ErrorMessageMissingSavePermission
    });
  }, [biLogger]);
  function handleLinkClick() {
    biLogger.notificationCtaClick({
      ctaName: BiCtaNames.MissingSavePermissionHelp,
      notificationType: BiNotificationTypes.ErrorMessageMissingSavePermission
    });
    window.open(getArticleLink(PERMISSIONS_ARTICLE_ID, locale ?? ''), '_blank');
  }
  return /*#__PURE__*/React.createElement(SectionHelper, {
    prefixIcon: /*#__PURE__*/React.createElement(StatusAlertSmall, null),
    size: "small",
    fullWidth: true,
    showPrefixIcon: true
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      Link: /*#__PURE__*/React.createElement(TextButton, {
        as: "a",
        size: "small",
        skin: "dark",
        underline: "always",
        weight: "thin",
        ellipsis: true,
        onClick: handleLinkClick
      })
    },
    i18nKey: "accessibility-wizard.missing-save-permission-error.description",
    t: t
  })));
};
//# sourceMappingURL=missing-save-permission-warning.js.map